import logoWhite from "../assets/logowhite.png";
import BlockBlitz from "../assets/BlockBlitz.png";
import PockliImage from "../assets/pockli.jpeg";

const apps = [
  {
    id: "vortex-block-blitz",
    title: "Block Blitz",
    name: "block puzzle mobile game",
    image: BlockBlitz,
    storeUrl:
      "https://play.google.com/store/apps/details?id=app.rork.vortax_block_puzzle",
    policyUrl: "/privacy-policy/block-blitz",
  },
  {
    id: "pockli",
    title: "Pockli",
    name: "Simple personal finance tracking",
    image: PockliImage,
    storeUrl: "https://apps.apple.com",
    policyUrl: "/privacy-policy/pockli",
  },
  {
    id: "codemap",
    title: "CodeMap",
    name: "Developer utility app",
    image: logoWhite,
    storeUrl: "https://play.google.com/store",
  },
];

function AppsPage() {
  return (
    <section className="apps-section">
      <p className="eyebrow">Apps</p>
      <h1>Products & Apps</h1>
      <p className="subtitle">Our latest products and game experiences.</p>
      <p className="content">
        Each app block includes a quick summary and a direct store button.
      </p>

      <div className="apps-grid">
        {apps.map((app) => (
          <article className="app-card" key={app.id}>
            <img className="app-image" src={app.image} alt={app.title} />
            <h3>{app.title}</h3>
            <p>{app.name}</p>
            <div className="app-actions">
              <a
                className="store-button"
                href={app.storeUrl}
                target="_blank"
                rel="noreferrer"
              >
                Download
              </a>
              {app.policyUrl ? (
                <a className="secondary-button" href={app.policyUrl}>
                  Privacy Policy
                </a>
              ) : null}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default AppsPage;
